<template>
  <div class="content">
    <div class="content-left">
      <!-- <div class="content-left-box">
        <div style="width: 100%;font-size: 1.7vh;color: #d2d2d2;font-weight: 800;">
          空气质量雷达图
        </div>
        <div style="width: 100%;height: 90%;" ref="le1"></div>
      </div> -->
      <div class="line-1" @click="jumpCad"></div>
      <div class="line-2">B2</div>
      <div class="line-3">产业2号楼末端能源优化系统项目</div>

      <div class="box-1">
        <div
          style="width: 100%;font-weight: 800;font-size: 2vh;display: flex;justify-content: space-between;box-sizing: border-box;padding: 0 2% 0 2%;align-items: end;">
          <div>设备运维管理</div>
          <div style="display: flex;align-items: center;width: 49%;justify-content: space-between;">
            <div style="display: flex;align-items: center;">
              <div style="width: 15px;height: 10px;background-color: #99C663;margin-right: 5px;"></div>
              <div style="font-size: 1.5vh;margin-right: 10px;">舒适区</div>
              <div style="width: 15px;height: 10px;background-color: #424EA5;margin-right: 5px;"></div>
              <div style="font-size: 1.5vh;margin-right: 10px;">偏冷区</div>
              <div style="width: 15px;height: 10px;background-color: #D9AF54;margin-right: 5px;"></div>
              <div style="font-size: 1.5vh;margin-right: 10px;">偏热区</div>
              <div style="width: 15px;height: 10px;background-color: #75C889;margin-right: 5px;"></div>
              <div style="font-size: 1.5vh;margin-right: 10px;">空气好</div>
              <div style="width: 15px;height: 10px;background-color: #B36F4F;margin-right: 5px;"></div>
              <div style="font-size: 1.5vh;margin-right: 10px;">空气差</div>
            </div>
            <div style="margin-right: 10px;">环境舒适度</div>
          </div>
        </div>
        <div style="width: 100%;display: flex;justify-content: space-between;height: 80%;align-items: center;">
          <div style="width: 49%;height: 100%;padding-left: 2%;display: flex;align-items: center;flex-wrap: wrap;">
            <div style="width: 100%;display: flex;justify-content: space-between;align-items: center;">
              <div class="flex-center" style="width: 130px;justify-content: flex-start;">
                <div class="ling-box" style="background-color: #FEDA66;margin-right: 13px"></div>
                <span style="font-size: 1.5vh;">风机盘管</span>
              </div>
              <span style="width: 100px;font-size: 1.5vh;">总数：218</span>
              <span style="width: 100px;font-size: 1.5vh;">运行：<span style="color:#05CDE5">{{ onlineOn }}</span></span>
              <span style="width: 100px;font-size: 1.5vh;">异常：<span style="color: red;">0</span></span>
            </div>
            <div style="width: 100%;display: flex;justify-content: space-between;align-items: center;">
              <div class="flex-center" style="width: 130px;justify-content: flex-start;">
                <div class="ling-box" style="background-color: #FDA4A5;;margin-right: 13px"></div>
                <span style="font-size: 1.5vh;">新风机组</span>
              </div>
              <span style="width: 100px;font-size: 1.5vh;">总数：10</span>
              <span style="width: 100px;font-size: 1.5vh;">运行：<span style="color:#05CDE5">0</span></span>
              <span style="width: 100px;font-size: 1.5vh;">异常：<span style="color: red;">0</span></span>
            </div>
            <div style="width: 100%;display: flex;justify-content: space-between;align-items: center;">
              <div class="flex-center" style="width: 130px;justify-content: flex-start;">
                <div class="ling-box" style="background-color: #F99EE4;margin-right: 13px"></div>
                <span style="font-size: 1.5vh;">照明回路</span>
              </div>
              <span style="width: 100px;font-size: 1.5vh;">总数：174</span>
              <span style="width: 100px;font-size: 1.5vh;">运行：<span style="color:#05CDE5">{{ ligOn }}</span></span>
              <span style="width: 100px;font-size: 1.5vh;">异常：<span style="color: red;">0</span></span>
            </div>
            <div style="width: 100%;display: flex;justify-content: space-between;align-items: center;">
              <div class="flex-center" style="width: 130px;justify-content: flex-start;">
                <div class="ling-box" style="background-color: #78CDF2;;margin-right: 13px"></div>
                <span style="font-size: 1.5vh;">照明配电箱</span>
              </div>
              <span style="width: 100px;font-size: 1.5vh;">总数：7</span>
              <span style="width: 100px;font-size: 1.5vh;">运行：<span style="color:#05CDE5">7</span></span>
              <span style="width: 100px;font-size: 1.5vh;">异常：<span style="color: red;">0</span></span>
            </div>
            <div style="width: 100%;display: flex;justify-content: space-between;align-items: center;">
              <div class="flex-center" style="width: 130px;justify-content: flex-start;">
                <div class="ling-box" style="background-color: #26EAB1;;margin-right: 13px"></div>
                <span style="font-size: 1.5vh;">排风机</span>
              </div>
              <span style="width: 100px;font-size: 1.5vh;">总数：1</span>
              <span style="width: 100px;font-size: 1.5vh;">运行：<span style="color:#05CDE5">{{ fanValue }}</span></span>
              <span style="width: 100px;font-size: 1.5vh;">异常：<span style="color: red;">0</span></span>
            </div>
            <div style="width: 100%;display: flex;justify-content: space-between;align-items: center;">
              <div class="flex-center" style="width: 130px;justify-content: flex-start;">
                <div class="ling-box" style="background-color: #3BA3D9;;margin-right: 13px"></div>
                <span style="font-size: 1.5vh;">楼层配电柜 </span>
              </div>
              <span style="width: 100px;font-size: 1.5vh;">总数：5</span>
              <span style="width: 100px;font-size: 1.5vh;">运行：<span style="color:#05CDE5">5</span></span>
              <span style="width: 100px;font-size: 1.5vh;">异常：<span style="color: red;">0</span></span>
            </div>
            <!-- <div style="width: 100%;font-size: 1.7vh;display: flex;align-items: center;justify-content: space-between;">
              <div style="display: flex;width: 30%;align-items: center;justify-content: center;">
                <div class="ling-box" style="background-color: #FB5343;">
                </div>
                <span>冷冻站侧总供冷量：</span>
              </div>
              <span style="color: #6EDCE4;margin-left: 5%;">{{
                len
              }}MJ/天 &nbsp;&nbsp; <span style="color: #fff;">约耗电&nbsp;&nbsp; </span> {{ lend }}kW·h</span>
            </div>
            <div style="width: 100%;font-size: 1.7vh;display: flex;align-items: center;justify-content: space-between;">
              <div style="display: flex;width: 30%;align-items: center;justify-content: flex-start;">
                <div class="ling-box" style="background-color: #FB5343;">
                </div>
                <span>B2建筑总用电量：</span>
              </div>
              <span style="color: #6EDCE4;margin-left: 5%;">{{ dian }}kW·h</span>
            </div>
            <div style="width: 100%;font-size: 1.7vh;display: flex;align-items: center;justify-content: space-between;">
              <div style="display: flex;width: 60%;align-items: center;justify-content: flex-start;">
                <div class="ling-box" style="background-color: #FEDA66;"></div>
                空调总水流量/改造前流量：
              </div>
              <span style="color: #6EDCE4;">{{ liu }}吨/天
                &nbsp;&nbsp;/</span><span style="color: #fff;"> 4173吨/天</span>
            </div>
            <div style="width: 100%;font-size: 1.7vh;display: flex;align-items: center;justify-content: space-between;">
              <div style="display: flex;width: 50%;align-items: center;justify-content: flex-start;">
                <div class="ling-box" style="background-color: #78CDF2;"></div>
                B2建筑总能耗/CO2排放量：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </div>
              <span style="color: #6EDCE4;">{{ zong }}kW·h &nbsp;&nbsp;&nbsp;/&nbsp; &nbsp;&nbsp;{{ tan
                }}kg/天
              </span>
            </div> -->
          </div>
          <div class="line-y"></div>
          <div
            style="width: 49%;height: 100%;display: flex;align-items: center;flex-wrap: wrap;justify-content: space-between;"
            class="box-006">
            <div style="width: 49%;height: 100%;" ref="ech77">
            </div>
            <div style="width: 49%;height: 100%;" ref="ech88"></div>
            <!-- <div style="width: 100%;height: 100%;" ref="barbi"></div> -->
            <!--  <div style="width: 100%;font-size: 1.7vh;display: flex;padding-left: 5%;align-items: center;">
              <div class="ling-box" style="background-color: #26EAB1;"></div> 每平米碳排放量：<span
                style="color: #6EDCE4;margin-left: 3%;">{{ mtan }}kg/㎡/天</span>
            </div>

            <div
              style="width: 100%;font-size: 1.7vh;display: flex;padding-left: 5%;align-items: center;flex-wrap: wrap;">
              <div class="ling-box" style="background-color: #F99EE4;"></div>空调总水流量：<span
                style="color: #6EDCE4;margin-left: 8%;">{{ liu }}吨/天</span>
              <div style="width: 100%;font-size: 1.5vh;margin-left: 2%;color: #6B6969;">
                改造前流量(按额定流量0.8折计算)：4173吨/天
              </div>
            </div>
            <div
              style="width: 100%;font-size: 1.2vh;display: flex;padding-left: 60%;align-items: center;cursor: pointer;padding-top: 2%;"
              @click="dialogVisible = true">
              <div class="btn-nh">节能估算</div>
            </div> -->
          </div>
        </div>
        <!--<div style="width:100%;overflow: hidden;">
          <div style="width:100%;padding-left:3%">
            <div style="width: 100%;font-weight: 500;display: flex">
              <div style="width: 60%;">B2建筑总制冷量：</div>
              <div>{{ len }}MJ/天</div>
            </div>
            <div style="width: 100%;font-weight: 500;display: flex">
              <div style="width: 60%;"> B2建筑总用电量：</div>
              <div>{{ dian }}kW·h/天</div>
            </div>
            <div style="width: 100%;font-weight: 500;display: flex">
              <div style="width: 60%;"> B2建筑总碳排放量：</div>
              <div>{{ tan }}kg/天</div>
            </div>
            <div style="width: 100%;font-weight: 500;display: flex">
              <div style="width: 60%;">B2建筑每平米碳排放量：</div>
              <div>{{ mtan }}kg/㎡/天</div>
            </div>
            <div style="width: 100%;font-weight: 500;display: flex">
              <div style="width: 60%;">B2建筑总空调水流量：</div>
              <div>{{ liu }}吨/天</div>
            </div>
            <div style="width:100%;font-size:10px;color:#6B6969">改造前流量(按额定流量0.8折计算)：4173吨/天</div>
            <div style="width:100%;font-size:10px;color:#6B6969;">本数据根据前一日系统运行数据计算,计算时间为本日0点0分</div>
          </div>
        </div>  -->
      </div>
    </div>
    <div class="content-right">
      <div class="right-box-one">
        <div class="home_tit">{{ homeTime }}</div>
        <div class="home_tit">{{ weather }}</div>
        <div class="home_tit">{{ temp }}℃</div>
      </div>
      <div class="right-box" style="display: flex;justify-content:space-between;align-items: center;">
        <div style="width: 59%;height: 100%;">
          <div style="width: 100%;font-size: 1.7vh;color: #d2d2d2;font-weight: 800;margin-left: 2%;">
            B2 7日用电量统计(单位：kWh)
          </div>
          <div style="width: 100%;height: 90%;" ref="ech1"></div>
        </div>
        <div class="line-y"></div>
        <div style="width: 39%;height: 100%">
          <div style="width: 100%;font-size: 1.7vh;color: #d2d2d2;font-weight: 800;">
            各楼层用电量统计
          </div>
          <div style="width: 100%;height: 90%;" ref="bin1"></div>
        </div>
      </div>
      <div class="right-box">
        <div style="width: 100%;font-size: 1.7vh;color: #d2d2d2;font-weight: 800;" class="flex-span-btn">
          <div style="margin-left: 2%;">B2 近24小时电功率统计(单位：kW)</div>
          <!-- <div style='color:#E5E411;margin-right:3.5%'>{{gonglu}}kw</div> -->
          <div style="margin-right:3.5%"><span style="font-size:1.2vh;color:rgb(107 105 105);">当前功率：</span>
            <span style="color:#E5E411;font-size:3vh">{{ gonglu }}</span>kW
          </div>
        </div>
        <div style="width: 100%;height: 80%;" ref="ech3"></div>
      </div>
      <div class="right-box" style="display: flex;justify-content:space-between;align-items: center;">

        <div style="width: 59%;height: 100%;position: relative;">
          <div class="line-4">空调水累计流量：{{ dayliu }}t</div>
          <div
            style="width: 100%;font-size: 1.7vh;color: #d2d2d2;font-weight: 800;box-sizing: border-box;padding-right: 20px;"
            class="flex-span-btn">
            <div style="margin-left: 2%;">B2 改造前后24小时空调水流量趋势图</div>
            <div>
              <span style="color:#E5E411;font-size:3vh">{{ lines1 }}</span>%
            </div>
          </div>
          <div style="width: 100%;height: 80%;" ref="ech7"></div>
        </div>
        <div class="line-y"></div>
        <div style="width: 39%;height: 100%;">
          <div style="width: 100%;font-size: 1.7vh;color: #d2d2d2;font-weight: 800;" class="flex-span-btn">
            <div style="margin-left: 2%;">B2 改造前后空调水流量实时对比图</div>
          </div>
          <div style="width: 100%;height: 90%;" ref="bin3"></div>
        </div>
      </div>
      <div class="right-box" style="display: flex;justify-content:space-between;align-items: center;">
        <div style="width: 59%;height: 100%;">
          <div style="width: 100%;font-size: 1.7vh;color: #d2d2d2;font-weight: 800;margin-left: 2%;">
            B2 近7天热量统计(MJ)
          </div>
          <div style="width: 100%;height: 90%;" ref="ech2"></div>
        </div>
        <div class="line-y"></div>
        <div style="width: 39%;height: 100%;">
          <div style="width: 100%;font-size: 1.7vh;color: #d2d2d2;font-weight: 800;">
            B2 各层热量占比图
          </div>
          <div style="width: 100%;height: 90%;" ref="bin2"></div>
        </div>
      </div>

    </div>
    <div class="dialog-main" v-if="dialogVisible">
      <div class="dialog-box">
        <div class="dialog-header">
          <div class="dialog-title">节能估算
          </div>
          <i class="el-icon-close dialog-close" @click="dialogVisible = false"></i>
        </div>
        <div class="dialog-bottom"></div>
        <div class="dialog-body">
          <div class="dialog-body-box"> <span class="dialog-body-main"
              style="font-size: 1.7vh;font-style: italic;">计算参考数据</span></br>
          </div>
          <div class="dialog-body-box"> <span class="dialog-body-main"
              style="color: #61D0D8;font-size: 1.8vh;">3550kW·h/天</span></br>
          </div>
          <div class="dialog-body-box"> <span class="dialog-body-main"
              style="font-size: 1.8vh;color: #6B6969;">气温在31~37度时工作日耗电量，7、8月份60天均按此数值计算。</span></br>
          </div>
          <div class="dialog-body-box"> <span class="dialog-body-main"
              style="color: #61D0D8;font-size: 1.8vh;">2550kW·h/天</span></br>
          </div>
          <div class="dialog-body-box"> <span class="dialog-body-main"
              style="font-size: 1.8vh;color: #6B6969;">气温在26~30度时工作日耗电量，5、6、9月90天均按此数值计算。</span></br>
          </div>
          <div class="dialog-body-box"><span class="dialog-body-main"
              style="color: #61D0D8;font-size: 1.8vh;">2550kW·h/天</span></br>
          </div>
          <div class="dialog-body-box"><span class="dialog-body-main"
              style="font-size: 1.8vh;color: #6B6969;">冬季供暖暂估耗电量，12月5日~3月5日90天按此数值计算。</span></br></div>
          <div class="dialog-body-box"><span class="dialog-body-main"
              style="color: #61D0D8;font-size: 1.8vh;">750kW·h/天</span></br>
          </div>
          <div class="dialog-body-box"><span class="dialog-body-main"
              style="font-size: 1.8vh;color: #6B6969;">空调不工作时工作日耗电量，3、4、10、11月120天按此数值计算。</span></br>
          </div>
          <div class="dialog-body-box"> <span class="dialog-body-main"
              style="font-size: 1.7vh;font-style: italic;">节能计算</span></br>
          </div>
          <div class="dialog-body-box"> <span class="dialog-body-main" style="font-size: 1.8vh;color: #D2D2D2;">
              3550*0.8*60<span style="color:#6B6969">（高制冷负荷段：7、8月）</span>+2550*0.8*90
              <span style="color:#6B6969">（中制冷负荷段5、6、9、月）</span>+750*0.8*120<span
                style="color:#6B6969">（过度季3、4、10、11）</span>+2550*0.8*90<span
                style="color:#6B6969">（供暖季12月5~3月5日）</span>=609600元 <span
                style="color:#6B6969">(1kW·h以0.8元计算)</span></span>
            </br>
          </div>
          <!-- <div class="dialog-body-box"><span class="dialog-body-main"
              style="font-size: 1.8vh;font-weight: 800;">以B2改造前每年200万电费估算,节省69.5%</span></br></div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
import service from '../../../service/leftService'
export default {
  name: '',
  props: [''],
  data() {
    return {
      dialogVisible: false,
      temp: '',
      homeTime: '',
      weather: '',
      timmer: null,
      timeE1: null,
      len: '',
      lendesc: '',
      lend: "",
      dian: '',
      zong: '',
      tan: "",
      tandesc: "",
      mtan: '',
      line: '',
      lines1: '',
      liu: '',
      gonglu: '',
      dayliu: '0.0',
      onlineOn: 234,
      ligOn: "118",
      fanValue: 0
    };
  },
  components: {
  },
  computed: {},
  beforeMount() { },
  mounted() {
    let _this = this
    this.getTime()
    this.hefeng()
    this.getNeAndTan()
    this.$nextTick(() => {
      _this.getEchartsData()
      _this.getHistoryData()
      this.timmer = setInterval(() => {
        _this.getTime()
      }, 1000);
      this.timeE1 = setInterval(() => {
        _this.getEchartsData()
        _this.getHistoryData()
      }, 5000)
    })
  },
  provide() {
  },
  methods: {
    getEchartsData() {
      service.getOnlineData("664b1458a75b1f15aba811b5").then(res => {
        res.forEach(item => {
          if (item.type == "valve") {
            this.onlineOn = item.online
            let onLine = ((item.online / item.total) * 100).toFixed(1) // 值
            this.line = onLine
            let zo = 100 - onLine
            let kai = (item.online * 0.21 * 3.6).toFixed(1)
            let bin3 = echarts.init(this.$refs.bin3);
            bin3.setOption(
              {
                color: ["#78CDF2", "#FEDA66", "#c9ae54"], // 蓝 黄
                grid: {
                  top: '5%',
                  left: '0%', //grid 组件离容器左侧的距离。
                  right: '5%', //grid 组件离容器右侧的距离。
                  bottom: '0%', //grid 组件离容器下侧的距离。
                  containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
                },
                title: {
                  text: '',
                  top: 'middle',
                  left: 'center',
                  textStyle: {
                    color: '#FEDA66',
                    fontSize: 15
                  }
                },
                tooltip: {
                  trigger: 'item',
                  formatter: function (params) {
                    // params 是包含数据信息的对象
                    // return '自定义内容：' + params.name + ' - ' + params.value;
                    if (params.id == 0) {
                      return ""
                    } else {
                      return `${params.value}%`
                    }
                  }
                },
                legend: {
                  orient: 'vertical',
                  left: 'left',
                  show: false
                },
                series: [
                  {
                    name: '',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    data: [
                      { value: zo, name: '', labelLine: { show: false }, id: 0 },
                      { value: onLine, name: `${kai}t/h`, id: 2 },

                    ],
                    emphasis: {
                      itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                      }
                    },
                    labelLine: {
                      normal: {
                        show: true,
                        minLength: 0, // 设置最小长度，0表示始终显示
                        length: 1,   // 指引线长度
                        length2: 10,  // 第二条指引线长度，长度为从内半径到此处的线长
                        smooth: 0.2,  // 指引线平滑度
                        lineStyle: {
                          // 指引线样式
                          width: 1,
                          type: 'solid'
                        }
                      }
                    }
                  }
                ]
              }
            )
            window.addEventListener('resize', () => {
              bin3.resize()
            })
            bin3.setOption({
              title: {
                text: onLine + "%"
              }
            })
          }
          if (item.type == 'light') {
            this.ligOn = item.online
          }
        })
      })

      let obj = {
        args: ['B2排风机状态数据接口-CAD图用']
      }
      service.getPublicData(obj).then(res => {
        if (res[0].value == 0) {
          this.fanValue = 0
        } else {
          this.fanValue = 1
        }
      })
    },
    // 获取柱状图
    getHistoryData() {
      let timestamp = Date.now();
      // 获取昨天的日期
      const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
      // 获取昨天24小时开始时间的时间戳
      const startOfYesterday24Hours = yesterday.setHours(0, 0, 0, 0);
      // 获取昨天24小时结束时间的时间戳
      const endOfYesterday24Hours = yesterday.setHours(23, 59, 59, 999);
      // 往前推24天的时间戳
      const time24 = new Date(new Date().setDate(new Date().getDate() - 24))
      const time24data = time24.getTime()

      let ob = {
        args: ['今日水阀累计开启时间-数据接口']
      }
      service.getPublicData(ob).then(res => {
        this.dayliu = (res[0].value * 0.756).toFixed(1)
      })
      // 获取用电量柱状图
      let obj = {
        "startTime": 1718694604853,
        "stopTime": timestamp,
        "ids": [
          "66791eec06499a563567e1e3"
        ]
      }
      service.getHistogram(obj).then(res => {
        let time = res[0].times.slice(-7)
        let arr = []
        let xrr = []
        let yData = res[0].val[0].value.slice(-7)
        for (let i = 0; i < yData.length; i++) {
          arr.push(parseFloat(yData[i][1]).toFixed(1))
        }
        for (let q = 0; q < time.length; q++) {
          let t = time[q].split("")
          let ti = `${t[5]}${t[6]}-${t[8]}${t[9]}`
          xrr.push(ti)
        }
        let pieOne1 = echarts.init(this.$refs.ech1);
        pieOne1.setOption(
          {
            color: ["#2B52E1"],
            grid: {
              top: '15%',
              left: '1%', //grid 组件离容器左侧的距离。
              right: '4%', //grid 组件离容器右侧的距离。
              bottom: '3%', //grid 组件离容器下侧的距离。
              containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
            },
            tooltip: {
              trigger: 'item',
              formatter: function (params) {
                // params 是包含数据信息的对象
                // return '自定义内容：' + params.name + ' - ' + params.value;
                return `${params.value}kW·h`
              }
            },
            xAxis: {
              type: 'category',
              data: xrr,
              axisLine: {
                lineStyle: {
                  color: '#d2d2d2' //坐标轴线线的颜色。
                }
              },
            },
            yAxis: [{
              min: 0,
              type: 'value', //坐标轴类型。'value' 数值轴，适用于连续数据;'category' 类目轴，适用于离散的类目数据，为该类型时必须通过 data 设置类目数据;'time' 时间轴;'log' 对数轴.
              name: '', //坐标轴名称。
              axisTick: {
                show: false //是否显示坐标轴刻度
              },
              axisLine: {
                lineStyle: {
                  show: false,
                  color: '#d2d2d2', //坐标轴线线的颜色
                  textStyle: {
                    fontSize: 18, //文字的字体大小
                    fontWeight: '900',
                  }
                }
              },
              axisLabel: {
                show: true,
                margin: 10, //刻度标签与轴线之间的距离
                color: '#d2d2d2',
                textStyle: {
                  fontSize: 12, //文字的字体大小
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: '#143592' //分隔线颜色设置
                }
              }
            }],
            series: [
              {
                data: arr,
                type: 'bar',
                barWidth: '50%', // 设置为类目宽度的50%
                label: {
                  show: true, // 显示数据
                  position: 'top', // 数据显示在柱状图上方
                  textStyle: { color: '#D2D2D2' }
                },
                itemStyle: { // 使用方法一的写法
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#3CA8E0' },
                    { offset: 1, color: '#3ca9e000' }
                  ])
                }
              }
            ]
          }
        )
        window.addEventListener('resize', () => {
          pieOne1.resize()
        })

      })
      // 获取个楼层数据能能耗
      let obj1 = {
        args: ["5层每天制热量数据接口", "4层每天制热量数据接口", "3层每天制热量数据接口", "2层每天制热量数据接口", "1层每天制热量数据接口"]
      }
      service.getPublicData(obj1).then(res => {
        debugger
        let f1 = 1
        let f2 = 1
        let f3 = 1
        let f4 = 1
        let f5 = 1
        res.forEach(item => {
          if (item.secondName == "五层") {
            f5 = item.value
          } else if (item.secondName == "四层") {
            f4 = item.value
          } else if (item.secondName == "三层") {
            f3 = item.value
          } else if (item.secondName == "二层") {
            f2 = item.value
          } else if (item.secondName == "一层") {
            f1 = item.value
          }
        })
        // 热功耗占比图
        let bin2 = echarts.init(this.$refs.bin2);
        bin2.setOption(
          {
            color: ["#FEDA66", "#FDA4A5", "#F99EE4", "#78CDF2", "#26EAB1"],
            grid: {
              top: '5%',
              left: '3%', //grid 组件离容器左侧的距离。
              right: '4%', //grid 组件离容器右侧的距离。
              bottom: '0%', //grid 组件离容器下侧的距离。
              containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
            },
            title: {
              text: '',
              top: 'middle',
              left: 'center',
              textStyle: {
                color: '#FEDA66',
                fontSize: 15
              }
            },
            tooltip: {
              trigger: 'item',
              formatter: function (params) {
                // params 是包含数据信息的对象
                // return '自定义内容：' + params.name + ' - ' + params.value;
                return `${params.value}MJ`
              }
            },
            legend: {
              orient: 'vertical',
              left: 'left',
              show: false
            },
            series: [
              {
                name: '热功耗',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                data: [
                  { value: f1, name: 'F1' },
                  { value: f2, name: 'F2' },
                  { value: f3, name: 'F3' },
                  { value: f4, name: 'F4' },
                  { value: f5, name: `F5` }
                ],
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                },
                labelLine: {
                  normal: {
                    show: true,
                    minLength: 0, // 设置最小长度，0表示始终显示
                    length: 5,   // 指引线长度
                    length2: 10,  // 第二条指引线长度，长度为从内半径到此处的线长
                    smooth: 0.2,  // 指引线平滑度
                    lineStyle: {
                      // 指引线样式
                      width: 1,
                      type: 'solid'
                    }
                  }
                }
              }
            ]
          }
        )
        let zong2 = Number(f1) + Number(f2) + Number(f3) + Number(f4) + Number(f5)
        let bi21 = ((Number(f1) / zong2) * 100).toFixed(1) + "%"
        let bi22 = ((Number(f2) / zong2) * 100).toFixed(1) + "%"
        let bi23 = ((Number(f3) / zong2) * 100).toFixed(1) + "%"
        let bi24 = ((Number(f4) / zong2) * 100).toFixed(1) + "%"
        let bi25 = ((Number(f5) / zong2) * 100).toFixed(1) + "%"
        bin2.setOption({
          title: {
            text: bi21
          }
        })
        bin2.on('click', function (params) {
          if (params.name == "F1") {
            bin2.setOption({
              title: {
                text: bi21,
                textStyle: {
                  color: '#FEDA66' // 这里设置标题颜色为红色
                }
              }
            })
          }
          if (params.name == "F2") {
            bin2.setOption({
              title: {
                text: bi22,
                textStyle: {
                  color: '#FDA4A5' // 这里设置标题颜色为红色
                }
              }
            })
          }
          if (params.name == "F3") {
            bin2.setOption({
              title: {
                text: bi23,
                textStyle: {
                  color: '#F99EE4' // 这里设置标题颜色为红色
                }
              }
            })
          }
          if (params.name == "F4") {
            bin2.setOption({
              title: {
                text: bi24,
                textStyle: {
                  color: '#78CDF2' // 这里设置标题颜色为红色
                }
              }
            })
          }
          if (params.name == "F5") {
            bin2.setOption({
              title: {
                text: bi25,
                textStyle: {
                  color: '#26EAB1' // 这里设置标题颜色为红色
                }
              }
            })
          }
        })

      })
      // 热功耗柱状图
      let obj2 = {
        "startTime": 1718694604853,
        "stopTime": timestamp,
        "ids": [
          "6745a95ec84401529872bcfc"
        ]
      }
      service.getHistogram(obj2).then(res => {
        let time = res[0].times.slice(-7)
        let arr = []
        let xrr = []
        let yData = res[0].val[0].value.slice(-7)
        for (let i = 0; i < yData.length; i++) {
          arr.push(parseFloat(yData[i][1]).toFixed(1))
        }
        for (let q = 0; q < time.length; q++) {
          let t = time[q].split("")
          let ti = `${t[5]}${t[6]}-${t[8]}${t[9]}`
          xrr.push(ti)
        }
        let ech2 = echarts.init(this.$refs.ech2);
        ech2.setOption(
          {
            color: ["#2B52E1"],
            grid: {
              top: '15%',
              left: '3%', //grid 组件离容器左侧的距离。
              right: '4%', //grid 组件离容器右侧的距离。
              bottom: '3%', //grid 组件离容器下侧的距离。
              containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
            },
            tooltip: {
              trigger: 'item',
              formatter: function (params) {
                // params 是包含数据信息的对象
                // return '自定义内容：' + params.name + ' - ' + params.value;
                return `${params.value}MJ`
              }
            },
            xAxis: {
              type: 'category',
              data: xrr,
              axisLine: {
                lineStyle: {
                  color: '#d2d2d2' //坐标轴线线的颜色。
                }
              },
            },
            yAxis: [{
              min: 0,
              type: 'value', //坐标轴类型。'value' 数值轴，适用于连续数据;'category' 类目轴，适用于离散的类目数据，为该类型时必须通过 data 设置类目数据;'time' 时间轴;'log' 对数轴.
              name: '', //坐标轴名称。
              axisTick: {
                show: false //是否显示坐标轴刻度
              },
              axisLine: {
                lineStyle: {
                  color: '#d2d2d2', //坐标轴线线的颜色
                  textStyle: {
                    fontSize: 18, //文字的字体大小
                    fontWeight: '900',
                  }
                }
              },
              axisLabel: {
                show: true,
                margin: 10, //刻度标签与轴线之间的距离
                color: '#d2d2d2',
                textStyle: {
                  fontSize: 12, //文字的字体大小
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: '#143592' //分隔线颜色设置
                }
              }
            }],
            series: [
              {
                data: arr,
                type: 'bar',
                barWidth: '50%', // 设置为类目宽度的50%
                itemStyle: { // 使用方法一的写法
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#3CA8E0' },
                    { offset: 1, color: '#3ca9e000' }
                  ])
                }
              }
            ]
          }
        )
        window.addEventListener('resize', () => {
          ech2.resize()
        })

      })
      // 获取工功率数据
      let obj3 = {
        "startTime": timestamp - (24 * 3600 * 1000),
        "stopTime": timestamp,
        "id": "667bbc2ab356f9625b626b97",
        "trendLogId": [
          "667bba9db356f9625b626b96"
        ]
      }
      service.trendLogShow(obj3).then(res => {
        let time = res[0].times
        let xrr = [] // 时间点位
        let arr = [] // 数据点位
        let yData = res[0].val[0].value
        for (let i = 0; i < yData.length; i++) {
          arr.push(yData[i][1])
        }
        for (let q = 0; q < time.length; q++) {
          let t = time[q].split("")
          let ti = `${t[11]}${t[12]}${t[13]}${t[14]}${t[15]}${t[16]}${t[17]}${t[18]}`
          xrr.push(ti)
        }
        this.gonglu = arr[arr.length - 1];
        let pieOne3 = echarts.init(this.$refs.ech3);
        pieOne3.setOption(
          {
            color: ['#00e6ff', "#ffd503"],
            tooltip: {
              trigger: 'item',
              axisPointer: {
                type: 'cross',
                label: {
                  backgroundColor: '#d2d2d2'
                }
              },
              formatter: function (params) {
                // params 是包含数据信息的对象
                // return '自定义内容：' + params.name + ' - ' + params.value;
                return `${params.value}kW`
              }
            },
            legend: {
              data: ['功率']
            },

            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              top: "10%",
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                boundaryGap: false,
                axisLine: {
                  lineStyle: {
                    color: '#d2d2d2' //坐标轴线线的颜色。
                  }
                },
                data: xrr
              }
            ],
            yAxis: [
              {
                min: 0,
                type: 'value',
                axisLine: {
                  lineStyle: {
                    color: '#d2d2d2', //坐标轴线线的颜色
                    textStyle: {
                      fontSize: 18, //文字的字体大小
                      fontWeight: '900',
                    }
                  }
                },
                axisLabel: {
                  margin: 10, //刻度标签与轴线之间的距离
                  color: '#d2d2d2',
                  textStyle: {
                    fontSize: 12, //文字的字体大小
                    /* fontWeight:'800', */
                  }
                },
                splitLine: {
                  show: false,
                  lineStyle: {
                    color: '#57617B' //分隔线颜色设置
                  }
                }
              }
            ],
            series: [
              {
                name: '',
                type: 'line',
                smooth: true,
                lineStyle: {
                  width: 1
                },
                showSymbol: false,
                areaStyle: {
                  opacity: 0.8,
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                    offset: 0,
                    color: '#04626c16'
                  },
                  {
                    offset: 1,
                    color: '#00a1b3'
                  }]),
                },
                emphasis: {
                  focus: 'series'
                },
                data: arr
              },
            ]
          }
        )
        window.addEventListener('resize', () => {
          pieOne3.resize()
        })
      })
      // 获取个楼层数据能能耗
      let obj4 = {
        args: ["每天的功率"]
      }
      service.getPublicData(obj4).then(res => {
        let f1 = 1
        let f2 = 1
        let f3 = 1
        let f4 = 1
        let f5 = 1
        res.forEach(item => {
          if (item.subDeviceName == "五层") {
            f5 = item.value
          } else if (item.subDeviceName == "四层") {
            f4 = item.value
          } else if (item.subDeviceName == "三层") {
            f3 = item.value
          } else if (item.subDeviceName == "二层") {
            f2 = item.value
          } else if (item.subDeviceName == "一层") {
            f1 = item.value
          }
        })
        // 热功耗占比图
        let bin1 = echarts.init(this.$refs.bin1);
        bin1.setOption(
          {
            color: ["#FEDA66", "#FDA4A5", "#F99EE4", "#78CDF2", "#26EAB1"],
            grid: {
              top: '5%',
              left: '3%', //grid 组件离容器左侧的距离。
              right: '4%', //grid 组件离容器右侧的距离。
              bottom: '0%', //grid 组件离容器下侧的距离。
              containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
            },
            title: {
              text: '',
              top: 'middle',
              left: 'center',
              textStyle: {
                color: '#FEDA66',
                fontSize: 15
              }
            },
            tooltip: {
              trigger: 'item',
              formatter: function (params) {
                // params 是包含数据信息的对象
                // return '自定义内容：' + params.name + ' - ' + params.value;
                if (params.id == 0) {
                  return ""
                } else {
                  return `${params.value}kW`
                }
              }
            },
            legend: {
              orient: 'vertical',
              left: 'left',
              show: false
            },
            series: [
              {
                name: '',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                data: [
                  { value: f1, name: 'F1' },
                  { value: f2, name: 'F2' },
                  { value: f3, name: 'F3' },
                  { value: f4, name: 'F4' },
                  { value: f5, name: `F5` }
                ],
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                },
                labelLine: {
                  normal: {
                    show: true,
                    minLength: 0, // 设置最小长度，0表示始终显示
                    length: 5,   // 指引线长度
                    length2: 10,  // 第二条指引线长度，长度为从内半径到此处的线长
                    smooth: 0.2,  // 指引线平滑度
                    lineStyle: {
                      // 指引线样式
                      width: 1,
                      type: 'solid'
                    }
                  }
                }
              }
            ]
          }
        )
        let zong = Number(f1) + Number(f2) + Number(f3) + Number(f4) + Number(f5)
        let bi11 = ((Number(f1) / zong) * 100).toFixed(1) + "%"
        let bi12 = ((Number(f2) / zong) * 100).toFixed(1) + "%"
        let bi13 = ((Number(f3) / zong) * 100).toFixed(1) + "%"
        let bi14 = ((Number(f4) / zong) * 100).toFixed(1) + "%"
        let bi15 = ((Number(f5) / zong) * 100).toFixed(1) + "%"
        bin1.setOption({
          title: {
            text: bi11
          }
        })
        bin1.on('click', function (params) {
          if (params.name == "F1") {
            bin1.setOption({
              title: {
                text: bi11,
                textStyle: {
                  color: '#FEDA66' // 这里设置标题颜色为红色
                }
              }
            })
          }
          if (params.name == "F2") {
            bin1.setOption({
              title: {
                text: bi12,
                textStyle: {
                  color: '#FDA4A5' // 这里设置标题颜色为红色
                }
              }
            })
          }
          if (params.name == "F3") {
            bin1.setOption({
              title: {
                text: bi13,
                textStyle: {
                  color: '#F99EE4' // 这里设置标题颜色为红色
                }
              }
            })
          }
          if (params.name == "F4") {
            bin1.setOption({
              title: {
                text: bi14,
                textStyle: {
                  color: '#78CDF2' // 这里设置标题颜色为红色
                }
              }
            })
          }
          if (params.name == "F5") {
            bin1.setOption({
              title: {
                text: bi15,
                textStyle: {
                  color: '#26EAB1' // 这里设置标题颜色为红色
                }
              }
            })
          }
        })
        window.addEventListener('resize', () => {
          bin1.resize()
        })
      })
      // 获取工功率数据
      let obj7 = {
        "startTime": timestamp - (24 * 3600 * 1000),
        "stopTime": timestamp,
        "id": "667beadc25498a4b3c054dac",
        "trendLogId": [
          "667a34ba06499a563567e36c"
        ]
      }
      service.trendLogShow(obj7).then(res => {
        let zon = 0
        let neng = 0
        let time = res[0].times
        let xrr = []
        let arr = []
        let arr1 = []
        let yData = res[0].val[0].value
        for (let i = 0; i < yData.length; i++) {
          zon += 230
          arr.push((yData[i][1] / 230 * 100).toFixed(0))
          neng += parseInt(yData[i][1])
          arr1.push(100)
        }
        /* alert(yData.length)
        alert(zon)
        alert(neng) */
        this.lines1 = (neng / zon * 100).toFixed(1)
        this.liu = (4173 * (neng / zon)).toFixed(1)
        for (let q = 0; q < time.length; q++) {
          let t = time[q].split("")
          let ti = `${t[11]}${t[12]}${t[13]}${t[14]}${t[15]}${t[16]}${t[17]}${t[18]}`
          xrr.push(ti)
        }
        let pieOne7 = echarts.init(this.$refs.ech7);
        pieOne7.setOption(
          {
            color: ['#00e6ff'],
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                label: {
                  backgroundColor: '#d2d2d2'
                }
              },
              trigger: 'item',
              formatter: function (params) {
                // params 是包含数据信息的对象
                // return '自定义内容：' + params.name + ' - ' + params.value;
                return `${params.value}%`
              }
            },
            legend: {
              data: ['功率']
            },

            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              top: "10%",
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                boundaryGap: false,
                axisLine: {
                  lineStyle: {
                    color: '#d2d2d2' //坐标轴线线的颜色。
                  }
                },
                data: xrr
              }
            ],
            yAxis: [
              {
                max: 100,
                min: 0,
                type: 'value',
                axisLine: {
                  lineStyle: {
                    color: '#d2d2d2', //坐标轴线线的颜色
                    textStyle: {
                      fontSize: 18, //文字的字体大小
                      fontWeight: '900',
                    }
                  }
                },
                axisLabel: {
                  margin: 10, //刻度标签与轴线之间的距离
                  color: '#d2d2d2',
                  textStyle: {
                    fontSize: 12, //文字的字体大小
                    /* fontWeight:'800', */
                  }
                },
                splitLine: {
                  show: false,
                  lineStyle: {
                    color: '#57617B' //分隔线颜色设置
                  }
                }
              }
            ],
            series: [
              {
                name: '',
                type: 'line',
                stack: 'Total',
                smooth: true,
                lineStyle: {
                  width: 1
                },
                showSymbol: false,
                areaStyle: {
                  opacity: 0.8,
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                    offset: 0,
                    color: '#04626c16'
                  },
                  {
                    offset: 1,
                    color: '#00a1b3'
                  }]),
                },
                emphasis: {
                  focus: 'series'
                },
                data: arr
              },
              {
                name: '',
                type: 'line',
                stack: 'Total',
                smooth: true,
                lineStyle: {
                  width: 0
                },
                showSymbol: false,
                areaStyle: {
                  opacity: 0.8,
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: '#2f5af75f'
                    },
                    {
                      offset: 1,
                      color: '#3b52a600'
                    }
                  ])
                },
                emphasis: {
                  focus: 'series'
                },
                data: arr1
              }
            ]
          }
        )
        window.addEventListener('resize', () => {
          pieOne7.resize()
        })
      })

      // 温湿度
      let obj8 = {
        args: ["五层温湿度数据接口", "四层温湿度数据接口", "三层温湿度数据接口", "二层温湿度数据接口", "一层温湿度数据接口"]
      }
      service.getPublicData(obj8).then(res => {
        let a = "0"
        let b = "0"
        let c = "0"
        let d = "0"

        let a4 = "0"
        let b4 = "0"
        let c4 = "0"
        let d4 = "0"

        let a3 = "0"
        let b3 = "0"
        let c3 = "0"
        let d3 = "0"

        let a2 = "0"
        let b2 = "0"
        let c2 = "0"
        let d2 = "0"

        let a1 = "0"
        let b1 = "0"
        let c1 = "0"
        let d1 = "0"
        res.forEach(item => {
          if (item.name == "AIR_Temp" && item.sn == "B2-533") { a = item.value }
          if (item.name == "AIR_Humd" && item.sn == "B2-533") { b = item.value }
          if (item.name == "AIR_CO2" && item.sn == "B2-533") { c = item.value }
          if (item.name == "AIR_VOC" && item.sn == "B2-533") { d = item.value }
          if (item.name == "AIR_Temp" && item.sn == "B2-433") { a4 = item.value }
          if (item.name == "AIR_Humd" && item.sn == "B2-433") { b4 = item.value }
          if (item.name == "AIR_CO2" && item.sn == "B2-433") { c4 = item.value }
          if (item.name == "AIR_VOC" && item.sn == "B2-433") { d4 = item.value }

          if (item.name == "AIR_Temp" && item.sn == "B2-332") { a3 = item.value }
          if (item.name == "AIR_Humd" && item.sn == "B2-332") { b3 = item.value }
          if (item.name == "AIR_CO2" && item.sn == "B2-332") { c3 = item.value }
          if (item.name == "AIR_VOC" && item.sn == "B2-332") { d3 = item.value }

          if (item.name == "AIR_Temp" && item.sn == "B2-233") { a2 = item.value }
          if (item.name == "AIR_Humd" && item.sn == "B2-233") { b2 = item.value }
          if (item.name == "AIR_CO2" && item.sn == "B2-233") { c2 = item.value }
          if (item.name == "AIR_VOC" && item.sn == "B2-233") { d2 = item.value }

          if (item.name == "AIR_Temp" && item.sn == "B2-133") { a1 = item.value }
          if (item.name == "AIR_Humd" && item.sn == "B2-133") { b1 = item.value }
          if (item.name == "AIR_CO2" && item.sn == "B2-133") { c1 = item.value }
          if (item.name == "AIR_VOC" && item.sn == "B2-133") { d1 = item.value }
          /* let pieOne4 = echarts.init(this.$refs.le1);
          pieOne4.setOption(
            {
              legend: {
                top: '1%',
                left: 'center',
                data: ['1F', '2F', '3F', '4F', '5F'],
                textStyle: { //图例文字的样式
                  color: '#fff',
                  fontSize: 12
                },
              },
              tooltip: {

              },
              radar: {
                radius: "70%", //大小
                nameGap: 1, // 图中工艺等字距离图的距离
                center: ["50%", "50%"], // 图的位置
                name: {
                  textStyle: {
                    color: "#ffffff",
                    fontSize: 12
                  },
                  formatter: function (name) {
                    return name;
                  }
                },
                indicator: [
                  { "name": 'CO2', "max": "3000" },
                  { "name": 'VOC', "max": "3000" },
                  { "name": '温度', "max": "50" },
                  { "name": '湿度', "max": "100" },
                ],
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: "rgba(153, 209, 246, 0.8)"
                  }
                },
                // 分割区域
                splitArea: {
                  show: false,
                  areaStyle: {
                    color: [
                      'rgba(222,134,85, 0)', 'rgba(222, 149, 85, 0.807)',
                      'rgba(222, 149, 85, 0.807)', 'rgba(110, 222, 85, 0.807)',
                      'rgba(110, 222, 85, 0.807)', 'rgba(110, 222, 85, 0.807)'
                    ].reverse()
                  }
                },
                splitLine: {
                  show: false,
                  lineStyle: {
                    width: 0,
                    color: "#0b5cff00" // 设置网格的颜色
                  }
                }
              },
              series: [

                {
                  name: "",
                  type: "radar",
                  symbol: "none",
                  itemStyle: {
                    normal: {
                      areaStyle: { type: "default" }
                    }
                  },
                  data: [
                    {
                      symbol: "none",
                      symbolSize: 5,
                      value: [500, 500, 27, 70],
                      areaStyle: { color: "#27ff0b" },
                      itemStyle: {
                        normal: {
                          borderWidth: 1,
                          color: "#27ff0b",
                          borderColor: "#27ff0b"
                        }
                      },
                      lineStyle: {
                        color: "#27ff0b",
                        width: 1
                      }
                    }
                  ]
                },
                {
                  name: "",
                  type: "radar",
                  symbol: "none",
                  itemStyle: {
                    normal: {
                      areaStyle: { type: "default" }
                    }
                  },
                  data: [
                    {
                      symbol: "none",
                      symbolSize: 5,
                      value: [0, 0, 23, 40],
                      areaStyle: { color: "#0b5cff" },
                      itemStyle: {
                        normal: {
                          borderWidth: 1,
                          color: "#0b5cff",
                          borderColor: "#0b5cff"
                        }
                      },
                      lineStyle: {
                        color: "#0b5cff",
                        width: 1
                      }
                    }
                  ]
                },
                {
                  name: "1F",
                  type: "radar",
                  symbol: "none",
                  itemStyle: {
                    normal: {
                      areaStyle: { type: "default" }
                    }
                  },
                  data: [
                    {
                      symbol: "none",
                      symbolSize: 5,
                      value: [c1, d1, a1, b1],
                      areaStyle: { color: "#00ddff33" },
                      itemStyle: {
                        normal: {
                          borderWidth: 1,
                          color: "#00ddff33",
                          borderColor: "#00ddffb2"
                        }
                      },
                      lineStyle: {
                        color: "#00ddffb2",
                        width: 1
                      }
                    }
                  ]
                },
                {
                  name: "2F",
                  type: "radar",
                  symbol: "none",
                  itemStyle: {
                    normal: {
                      areaStyle: { type: "default" }
                    }
                  },
                  data: [
                    {
                      symbol: "none",
                      symbolSize: 5,
                      value: [c2, d2, a2, b2],
                      areaStyle: { color: "#fffb0424" },
                      itemStyle: {
                        normal: {
                          borderWidth: 1,
                          color: "#fffb0424",
                          borderColor: "#0877F3"
                        }
                      },
                      lineStyle: {
                        color: "#0877F3",
                        width: 1
                      }
                    }
                  ]
                },
                {
                  name: "3F",
                  type: "radar",
                  symbol: "none",
                  itemStyle: {
                    normal: {
                      areaStyle: { type: "default" }
                    }
                  },
                  data: [
                    {
                      symbol: "none",
                      symbolSize: 5,
                      value: [c3, d3, a3, b3],
                      areaStyle: { color: "#8911ec2b" },
                      itemStyle: {
                        normal: {
                          borderWidth: 1,
                          color: "#8911ec2b",
                          borderColor: "#047489"
                        }
                      },
                      lineStyle: {
                        color: "#047489",
                        width: 1
                      }
                    }
                  ]
                },
                {
                  name: "5F",
                  type: "radar",
                  symbol: "none",
                  itemStyle: {
                    normal: {
                      areaStyle: { type: "default" }
                    }
                  },
                  data: [
                    {
                      symbol: "none",
                      symbolSize: 5,
                      value: [c, d, a, b],
                      areaStyle: { color: "#ec111122" },
                      itemStyle: {
                        normal: {
                          borderWidth: 1,
                          color: "#ec111122",
                          borderColor: "#373CFA"
                        }
                      },
                      lineStyle: {
                        color: "#373CFA",
                        width: 1
                      }
                    }
                  ]
                },
                {
                  name: "4F",
                  type: "radar",
                  symbol: "none",
                  itemStyle: {
                    normal: {
                      areaStyle: { type: "default" }
                    }
                  },
                  data: [
                    {
                      symbol: "none",
                      symbolSize: 5,
                      value: [c4, d4, a4, b4],
                      areaStyle: { color: "#8b06ff1d" },
                      itemStyle: {
                        normal: {
                          borderWidth: 1,
                          color: "#8b06ff1d",
                          borderColor: "#1556EE"
                        }
                      },
                      lineStyle: {
                        color: "#1556EE",
                        width: 1
                      }
                    }
                  ]
                },

              ]
            }
          )
          window.addEventListener('resize', () => {
            pieOne4.resize()
          }) */
        })
      })

      // 室外温度实时获取
      let obj9 = {
        args: ['室外温度数据接口']
      }
      service.getPublicData(obj9).then(res => {
        // this.temp = parseFloat(res[0].value).toFixed(1)
      })


      let obj10 = {
        args: ['B2一层温度数据接口', 'B2二层温度数据接口', 'B2三层温度数据接口', 'B2四层温度数据接口', 'B2五层温度数据接口']
      }
      service.getPublicData(obj10).then(res => {
        // 获取环境柱状图
        let pieOne77 = echarts.init(this.$refs.ech77);
        pieOne77.setOption(
          {
            color: ["#347CA9"],
            grid: {
              top: '23%',
              left: '5%', //grid 组件离容器左侧的距离。
              right: '10%', //grid 组件离容器右侧的距离。
              bottom: '0%', //grid 组件离容器下侧的距离。
              containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
            },
            tooltip: {
              trigger: 'item',
              formatter: function (params) {
                // params 是包含数据信息的对象
                // return '自定义内容：' + params.name + ' - ' + params.value;
                return `${params.value}℃`
              }
            },
            xAxis: {
              type: 'category',
              data: ['1F', '2F', '3F', '4F', '5F'],
              axisLine: {
                lineStyle: {
                  color: '#fff'
                }
              },
              axisTick: {
                show: false
              }
            },
            yAxis: {
              max: 34,
              min: 10,
              interval: 4,
              type: 'value',
              name: " 环境温度(单位：℃)",
              nameTextStyle: {
                color: "#fff",
                nameLocation: "start",
                padding: [0, 0, 0, 58]
              },
              axisTick: {
                show: false
              },
              // axisLabel: {
              //   formatter: '{value}'
              // },
              axisLine: {
                lineStyle: {
                  color: '#fff'
                }
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: '#424152' //分隔线颜色设置
                }
              },
              splitArea: {
                show: true,
                areaStyle: {
                  color: [
                    '#424ea5',
                    '#424ea5',
                    '#424ea5',
                    '#99c663',
                    '#d9af54',
                    '#d9af54',
                  ]
                }
              }
            },
            series: [
              {
                data: [res[0].value, res[1].value, res[2].value, res[3].value, res[4].value],
                type: 'bar',
                barWidth: '10',
                itemStyle: { // 使用方法一的写法
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#ffffff' },
                    { offset: 1, color: '#3ca9e000' }
                  ])
                }
              }
            ]
          }
        )
        window.addEventListener('resize', () => {
          pieOne77.resize()
        })
      })


      // 环境舒适度-CO2
      let obj11 = {
        args: ['B2一层CO2数据接口', 'B2二层CO2数据接口', 'B2三层CO2数据接口', 'B2四层CO2数据接口', 'B2五层CO2数据接口']
      }
      service.getPublicData(obj11).then(res => {
        let pieOne88 = echarts.init(this.$refs.ech88);
        pieOne88.setOption(
          {
            color: ["#347CA9"],
            grid: {
              top: '23%',
              left: '0%', //grid 组件离容器左侧的距离。
              right: '5%', //grid 组件离容器右侧的距离。
              bottom: '0%', //grid 组件离容器下侧的距离。
              containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
            },
            tooltip: {
              trigger: 'item',
              formatter: function (params) {
                // params 是包含数据信息的对象
                // return '自定义内容：' + params.name + ' - ' + params.value;
                return `${params.value}ppm`
              }
            },
            xAxis: {
              type: 'category',
              data: ['1F', '2F', '3F', '4F', '5F'],
              axisLine: {
                lineStyle: {
                  color: '#fff'
                }
              },
              axisTick: {
                show: false
              },
            },
            yAxis:
              [{
                max: 1200,
                min: 0,
                interval: 400,
                type: 'value',
                name: "空气质量(单位：ppm)",
                nameTextStyle: {
                  color: "#fff",
                  nameLocation: "start",
                  padding: [0, 0, 0, 40]
                },
                axisTick: {
                  show: false
                },
                // axisLabel: {
                //   formatter: '{value}'
                // },
                axisLine: {
                  lineStyle: {
                    color: '#ffffff'
                  }
                },
                splitLine: {
                  show: false,
                  lineStyle: {
                    color: '#99C663' //分隔线颜色设置
                  }
                },
                splitArea: {
                  show: true,
                  areaStyle: {
                    color: [
                      '#8dfaa1c3',
                      '#8dfaa1c3',
                      '#f8945dae',
                    ]
                  }
                },
              },
              ],

            series: [
              {
                data: [res[0].value, res[1].value, res[2].value, res[3].value, res[4].value],
                type: 'bar',
                barWidth: '10',
                itemStyle: { // 使用方法一的写法
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#ffffff' },
                    { offset: 1, color: '#d6e6ef64' }
                  ])
                }
              }
            ]
          }
        )
        window.addEventListener('resize', () => {
          pieOne88.resize()
        })
      })
    },
    // 获取时间
    getTime() {
      // 获取系统时间
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minute = date.getMinutes();
      let second = date.getSeconds();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      hour = hour < 10 ? "0" + hour : hour;
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      let timer = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
      this.homeTime = timer
    },
    // 和风天气数据接口 cb8885d03abc4412ab83212e87a4fddf
    hefeng() {
      return new Promise((resovle, reject) => {
        $.ajax({
          type: 'GET',
          url: 'https://devapi.qweather.com/v7/weather/now?location=101190101&key=cb8885d03abc4412ab83212e87a4fddf',
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          success: (data) => {
            this.temp = data.now.temp
            this.weather = data.now.text
          },
          erroe: (err) => {
            console.log(err)
          }
        })
      })
    },
    jumpCad() {
      // NariMain || NARI
      let url = this.$router.resolve({
        name: `NARI`,
        query: {

        }
      })
      window.open(url.href, '_blank')
      /* this.$router.push({
        name: 'NARI',
      }) */
    },
    getNeAndTan() {
      // 获取数据
      let obj = {
        args: ['B2电能电量制冷量数据接口']
      }
      service.getPublicData(obj).then(res => {
        let a = ""
        let b = ""
        res.forEach(item => {
          if (item.secondName == "Z_KW") {
            a = item.value
          }
          if (item.secondName == "Z_COOL") {
            b = parseInt(item.value)
          }
        })
        this.dian = parseInt(a).toFixed(2)
        this.len = (b / 1000).toFixed(1)

        let t = (this.len * (1 / 3.6)).toFixed(2)
        this.lendesc = `${t}kW·h/天`
        this.lend = (t / 4).toFixed(2)
        this.zong = parseInt(this.dian) + parseInt(this.lend)
        this.tan = (b / 3600 / 4 * 0.997 + a * 0.997).toFixed(2)
        let s = (this.tan * 0.997).toFixed(2)
        this.tandesc = `${s}kW·h/天`
        this.mtan = (this.tan / 10000).toFixed(2)
      })


      /* let energy = [0, 0, 0, 0, 0]
      let electric = [0, 0, 0, 0, 0]

      let n1 = {
        args: ["五层能耗电能数据接口-大屏首页", "四层能耗电能数据接口-大屏首页", "三层能耗电能数据接口-大屏首页", "二层能耗电能数据接口-大屏首页", "一层能耗电能数据接口-大屏首页"]
      }
      service.getPublicData(n1).then(res => {
        res.forEach(item => {
          if (item.deviceName == "五层") {
            if (item.secondName == "COOL") {
              energy[4] = (parseInt(item.value) * 0.069 / 1000).toFixed(1)
            }
            if (item.secondName == "KW") {
              electric[4] = parseInt(item.value).toFixed(1)
            }
          }
          if (item.deviceName == "四层") {
            if (item.secondName == "COOL") {
              energy[3] = (parseInt(item.value) * 0.069 / 1000).toFixed(1)
            }
            if (item.secondName == "KW") {
              electric[3] = parseInt(item.value).toFixed(1)
            }
          }
          if (item.deviceName == "三层") {
            if (item.secondName == "COOL") {
              energy[2] = (parseInt(item.value) * 0.069 / 1000).toFixed(1)
            }
            if (item.secondName == "KW") {
              electric[2] = parseInt(item.value).toFixed(1)
            }
          }
          if (item.deviceName == "二层") {
            if (item.secondName == "COOL") {
              energy[1] = (parseInt(item.value) * 0.069 / 1000).toFixed(1)
            }
            if (item.secondName == "KW") {
              electric[1] = parseInt(item.value).toFixed(1)
            }
          }
          if (item.deviceName == "一层") {
            if (item.secondName == "COOL") {
              energy[0] = (parseInt(item.value) * 0.069 / 1000).toFixed(1)
            }
            if (item.secondName == "KW") {
              electric[0] = parseInt(item.value).toFixed(1)
            }
          }
        })
        // 每天电能制冷量柱状图
        let barbi = echarts.init(this.$refs.barbi);
        barbi.setOption({
          grid: {
            left: '1%',
            right: '4%',
            bottom: '0%',
            top: 18,
            padding: '0 0 10 0',
            containLabel: true,
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: true,//坐标轴两边留白
              data: ['1F', '2F', '3F', '4F', '5F'],
              axisLabel: { //坐标轴刻度标签的相关设置。
                interval: 0,//设置为 1，表示『隔一个标签显示一个标签』
                margin: 15,
                textStyle: {
                  color: '#ffffff',
                  fontStyle: 'normal',
                  fontFamily: '微软雅黑',
                  fontSize: 12,
                }
              },
              axisTick: {//坐标轴刻度相关设置。
                show: false,
              },
              axisLine: {//坐标轴轴线相关设置
                lineStyle: {
                  color: '#fff',
                  opacity: 0.2
                }
              },
              splitLine: { //坐标轴在 grid 区域中的分隔线。
                show: false,
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              splitNumber: 5,
              axisLabel: {
                show: false,
                textStyle: {
                  color: '#a8aab0',
                  fontStyle: 'normal',
                  fontFamily: '微软雅黑',
                  fontSize: 12,
                }
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#fff'],
                  opacity: 0.06
                }
              }
            },
          ],
          series: [
            {
              name: '能耗',
              type: 'bar',
              data: energy,
              barWidth: 40,
              barGap: 0,//柱间距离
              label: {//图形上的文本标签
                normal: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#ffffff',
                    fontStyle: 'normal',
                    fontFamily: '微软雅黑',
                    fontSize: 12,
                  },
                },
              },
              itemStyle: {//图形样式
                normal: {
                  barBorderRadius: [0, 0, 0, 0],
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 1, color: '#3ca9e000'
                  }, {
                    offset: 0, color: '#3ca8e0'
                  }], false),
                },
              },
            },
            {
              name: '电能',
              type: 'bar',
              data: electric,
              barWidth: 40,
              barGap: 0,//柱间距离
              label: {//图形上的文本标签
                normal: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#ffffff',
                    fontStyle: 'normal',
                    fontFamily: '微软雅黑',
                    fontSize: 12,
                  },
                },
              },
              itemStyle: {//图形样式
                normal: {
                  barBorderRadius: [0, 0, 0, 0],
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 1, color: '#ffbb0006'
                  }, {
                    offset: 0, color: '#FEDA66'
                  }], false),
                },
              },
            }
          ]
        })
        window.addEventListener('resize', () => {
          barbi.resize()
        })
      }) */

    },
  },
  destroyed() {
    clearInterval(this.timmer)
    clearInterval(this.timeE1)
  },
  beforeDestroy() {
    clearInterval(this.timmer)
    clearInterval(this.timeE1)
  },
  watch: {
  }
}

</script>
<style scoped>
.content {
  width: 100%;
  height: 100%;
  /* background-color: #3e3e3e;*/
  position: relative;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-image: url('../../../../static/img/nr.jpg');
  background-size: 100% 100%;
  display: flex;
}

.content-left {
  width: 60%;
  height: 100%;
  position: relative;
}

.content-right {
  position: relative;
  width: 40%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 20px;
}

.right-box {
  width: 100%;
  height: 21%;
  /* border: 1px solid #5d63fa;*/
  box-sizing: border-box;
  padding: 5px 5px;
  margin-bottom: 2%;
  display: flex;
  border-radius: 5px;
  justify-content: space-between;
  flex-wrap: wrap;
  background-color: #262835c7;
}

.right-box-one {
  width: 100%;
  height: 6%;
  /* border: 1px solid #5d63fa; */
  box-sizing: border-box;
  padding: 5px 20px 5px 50%;
  margin-bottom: 2%;
  display: flex;
  border-radius: 5px;
  justify-content: space-between;
  flex-wrap: wrap;
}

.home_tit {
  height: 100%;
  display: flex;
  align-items: center;
  color: #CDCACD;
  font-size: 2vh;
  font-weight: 700;
}

.content-left-box {
  width: 400px;
  height: 430px;
  position: absolute;
  bottom: 1%;
  left: 1%;
}

.line-2 {
  font-size: 1.7vh;
  position: absolute;
  top: 33.5%;
  left: 38.1%;
  color: #FFFFFF;
  font-weight: 800;
}

.line-3 {
  width: 85%;
  font-size: 2.5vh;
  position: absolute;
  top: 5%;
  color: #718CC7;
  font-weight: 800;
  text-align: right;
  font-family: '宋体';
}

.line-4 {
  font-size: 1.5vh;
  position: absolute;
  left: 220px;
  top: 60px;
  color: #ffd900;
  font-weight: 800;
}

.box-1 {
  width: 98%;
  height: 20.2%;
  position: absolute;
  bottom: 5.5%;
  left: 2%;
  color: #D2D2D2;
  font-weight: 500;
  background-color: #262835c8;
  box-sizing: border-box;
  padding: 5px 5px 5px 5px;
  border-radius: 5px;
  font-size: 1.7vh;
}

.line-y {
  width: 2px;
  height: 95%;
  background-color: #454760;
}

.line-1 {
  width: 101px;
  height: 40px;
  position: absolute;
  top: 28%;
  left: 34.5%;
  background-image: url("../../../../static/img/diy/zb.gif");
  background-size: 100% 100%;
  cursor: pointer;
  transform: rotate(90deg);
}

.flex-span-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.ling-box {
  width: 1vh;
  height: 1vh;
  margin-right: 2%;
  border-radius: 2px;
  transform: rotate(45deg);
}

.dialog-main {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 999;
  background-color: rgba(0, 0, 29, 0.656);
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-box {
  width: 600px;
  height: 420px;
  background-color: #20212F;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0px 10px 0px 10px;
}

.dialog-header {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-bottom {
  width: 100%;
  height: 2px;
  background-image: linear-gradient(to right, #204da733 0%, #204CA7 50%, #204da733 100%);
}

.dialog-body {
  width: 100%;
  height: calc(100% - 50px);
  box-sizing: border-box;
  padding: 10px 0 0 0;
}

.dialog-title {
  font-size: 2vh;
  color: #D2D2D2;
  font-weight: 800;
}

.dialog-close {
  font-size: 2.5vh;
  color: #D2D2D2;
  cursor: pointer
}

.dialog-body-box {
  margin-bottom: 1px;
}

.dialog-body-main {
  color: #d2d2d2;
  margin-bottom: 5px;
}

.btn-nh {
  width: 100px;
  height: 30px;
  border-radius: 5px;
  border: 1px solid #E5E411;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.8vh;
  color: #E5E411;
}

.btn-nh:hover {
  box-shadow: 0 0 10px 0 #E5E411;
}

.tooltip-title-diy {
  font-size: 2vh;
}

.bgbox {
  background-image: url('../../../assets/diy/bgbox.png');
  background-size: 100% 100%;
  padding: 5px 10px 5px 10px
}

.box-1-title {
  width: 100%;
  padding: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('../../../assets/diy/xiao.png');
  background-size: 100% 100%;
  color: #16E4FC;
  font-size: 1.4vh;
}

.box-006 {
  /* background-image: url('../../../assets/diy/006.png'); */
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/graphically/nari/main.vue